import React, { useState } from 'react'
import styles from './MediaModal.module.scss'
import VideoPlayer from '../../../../../components/VideoPlayer/VideoPlayer'
import { GameControllerIcon, StarIcon, PeopleIcon, FilmIcon, TVIcon, EyeIcon, HeartIcon, CalendarIcon, DocumentIcon } from '../../../../../components/CustomIcons'

export default function MediaModal({ media, open, onClose }) {
  const [likeCount, setLikeCount] = useState(media?.likes_count || 0)
  const [isLiked, setIsLiked] = useState(media?.is_liked || false)

  if (!open || !media) return null

  const getContentIcon = (contentType) => {
    switch (contentType) {
      case 'press': return <DocumentIcon size={20} />
      case 'news': return <DocumentIcon size={20} />
      case 'reviews': return <FilmIcon size={20} />
      case 'letsplay': return <GameControllerIcon size={20} />
      case 'streamers': return <TVIcon size={20} />
      default: return <DocumentIcon size={20} />
    }
  }

  const getContentTypeLabel = (contentType) => {
    switch (contentType) {
      case 'press': return 'Пресс-статья'
      case 'news': return 'Новость'
      case 'reviews': return 'Видео-обзор'
      case 'letsplay': return "Let's Play"
      case 'streamers': return 'Стример'
      default: return 'Контент'
    }
  }

  const handleLike = async () => {
    try {
      // TODO: Implement API call to like/unlike
      setIsLiked(!isLiked)
      setLikeCount(isLiked ? likeCount - 1 : likeCount + 1)
    } catch (error) {
      console.error('Failed to toggle like:', error)
    }
  }

  const hasVideo = media.video_file || media.video_url
  const videoSource = media.video_file || media.video_url
  const sourceType = media.video_file ? 'file' : 'url'

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.mediaIcon}>
            {getContentIcon(media.type)}
          </div>
          <h3>{media.title || media.username || media.name}</h3>
          <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.contentType}>
            {getContentTypeLabel(media.type)}
          </div>

          {/* Cover Image */}
          {media.cover_image && !hasVideo && (
            <div className={styles.coverImageSection}>
              <img src={media.cover_image} alt={media.title} className={styles.coverImage} />
            </div>
          )}

          {/* Video Player for reviews and let's play */}
          {hasVideo && (
            <div className={styles.videoSection}>
              <VideoPlayer
                sourceType={sourceType}
                src={videoSource}
                poster={media.cover_image}
                title={media.title}
                episodeMeta={{
                  type: getContentTypeLabel(media.type),
                  duration: media.duration_min
                }}
                autoPlay={false}
              />
            </div>
          )}

          {media.description && (
            <div className={styles.description}>
              <h4>Описание:</h4>
              <p>{media.description}</p>
            </div>
          )}

          {media.body && (
            <div className={styles.content}>
              <h4>Содержание:</h4>
              <div className={styles.contentText}>{media.body}</div>
            </div>
          )}

          {media.stream_url && (
            <div className={styles.streamSection}>
              <h4>Прямая трансляция:</h4>
              <a href={media.stream_url} target="_blank" rel="noopener noreferrer" className={styles.streamLink}>
                Смотреть стрим
              </a>
            </div>
          )}

          <div className={styles.mediaStats}>
            <div className={styles.statsRow}>
              {media.views_count !== undefined && <span className={styles.stat}><EyeIcon size={14} style={{ marginRight: '4px' }} /> {media.views_count}</span>}
              {media.rating_avg !== undefined && <span className={styles.stat}><StarIcon size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />{media.rating_avg}</span>}
              <button 
                className={`${styles.likeButton} ${isLiked ? styles.liked : ''}`}
                onClick={handleLike}
              >
                <HeartIcon size={16} style={{ color: isLiked ? '#ff4444' : '#999', marginRight: '4px' }} /> {likeCount}
              </button>
              {media.followers_count && <span className={styles.stat}><PeopleIcon size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />{media.followers_count}</span>}
            </div>
            {media.created_at && (
              <span className={styles.date}><CalendarIcon size={14} style={{ marginRight: '4px' }} /> {new Date(media.created_at.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1')).toLocaleDateString('ru-RU')}</span>
            )}
          </div>

          {media.tags && media.tags.length > 0 && (
            <div className={styles.tags}>
              <h4>Теги:</h4>
              <div className={styles.tagList}>
                {media.tags.map((tag, index) => (
                  <span key={index} className={styles.tag}>#{tag}</span>
                ))}
              </div>
            </div>
          )}

          {media.author && (
            <div className={styles.author}>
              <h4>Автор:</h4>
              <p>{media.author}</p>
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.closeBtn} onClick={onClose}>
            Закрыть
          </button>
        </div>
      </div>
    </div>
  )
}